import { Box, Container, Typography, Paper } from '@mui/material';

export default function PrivacyPolicyPage() {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f5f5f5', py: 6 }}>
      <Container maxWidth="md">
        <Paper sx={{ p: 5, borderRadius: 3 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>개인정보 처리방침</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>최종 수정일: 2026년 2월 10일</Typography>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>1. 개인정보의 수집 및 이용 목적</Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            주식회사 케이지네트워크(이하 "회사")는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">회원 가입 및 관리: 회원 가입의사 확인, 회원제 서비스 제공에 따른 본인 식별·인증</Typography></li>
            <li><Typography variant="body1">서비스 제공: AI 채팅 서비스, 문서 처리 서비스, 팀 협업 기능 제공</Typography></li>
            <li><Typography variant="body1">마케팅 및 광고: 신규 서비스 개발 및 맞춤 서비스 제공, 이벤트 및 광고성 정보 제공</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>2. 수집하는 개인정보 항목</Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>회사는 다음의 개인정보 항목을 수집하고 있습니다:</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">필수항목: 이름, 이메일 주소, 비밀번호, 소속 회사/조직</Typography></li>
            <li><Typography variant="body1">선택항목: 프로필 사진, 전화번호</Typography></li>
            <li><Typography variant="body1">자동 수집 항목: IP 주소, 쿠키, 서비스 이용 기록, 접속 로그</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>3. 개인정보의 보유 및 이용 기간</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">회원 정보: 회원 탈퇴 시까지</Typography></li>
            <li><Typography variant="body1">서비스 이용 기록: 3년 (통신비밀보호법)</Typography></li>
            <li><Typography variant="body1">결제 정보: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>4. 개인정보의 파기 절차 및 방법</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">파기 절차: 불필요한 개인정보는 개인정보 보호책임자의 승인 후 파기</Typography></li>
            <li><Typography variant="body1">파기 방법: 전자적 파일 형태는 복구 불가능한 방법으로 영구 삭제, 종이 문서는 분쇄 또는 소각</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>5. 정보주체의 권리·의무 및 행사방법</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">개인정보 열람 요구</Typography></li>
            <li><Typography variant="body1">오류 등이 있을 경우 정정 요구</Typography></li>
            <li><Typography variant="body1">삭제 요구</Typography></li>
            <li><Typography variant="body1">처리정지 요구</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>6. 개인정보의 안전성 확보 조치</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">관리적 조치: 내부관리계획 수립·시행, 정기적 직원 교육</Typography></li>
            <li><Typography variant="body1">기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 개인정보의 암호화</Typography></li>
            <li><Typography variant="body1">물리적 조치: 전산실, 자료보관실 등의 접근통제</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>7. AI 서비스 관련 개인정보 처리 (AI기본법 준수)</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">업로드된 파일은 AI 처리(임베딩) 후 즉시 삭제됩니다</Typography></li>
            <li><Typography variant="body1">AI 대화 내용은 서비스 개선 목적으로 익명화하여 보관할 수 있습니다</Typography></li>
            <li><Typography variant="body1">개인정보가 포함된 콘텐츠는 자동 필터링되어 차단됩니다</Typography></li>
            <li><Typography variant="body1">AI 생성 콘텐츠에는 "AI 생성" 표시가 자동으로 부착됩니다</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>8. 개인정보 보호책임자</Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">개인정보 보호책임자: 김대경 대표</Typography></li>
            <li><Typography variant="body1">연락처: kz4network@gmail.com</Typography></li>
            <li><Typography variant="body1">전화번호: 032-351-9117</Typography></li>
          </Box>

          <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>9. 개인정보 처리방침 변경</Typography>
          <Typography variant="body1" sx={{ mb: 2, lineHeight: 1.8 }}>
            이 개인정보 처리방침은 2026년 2월 10일부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제 및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
          </Typography>

          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="body2" color="text.secondary">
              주식회사 케이지네트워크 | 대표이사: 김대경
            </Typography>
            <Typography variant="body2" color="text.secondary">
              경기도 부천시 은성로32 비1층(소사본동)
            </Typography>
            <Typography variant="body2" color="text.secondary">
              사업자등록번호: 747-87-02879 | 통신판매업 신고번호: 제 2024-부천소사-0543 호
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
